import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { GridCol } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { UserInteraction } from '@naf/user-interaction';
import { isNotTransientProp } from '../../../lib/shouldForwardProp';

export const ResultGridCol = styled(GridCol, { shouldForwardProp: isNotTransientProp })<{ $isInModal?: boolean }>`
  grid-column-start: 4;

  ${({ $isInModal }) =>
    $isInModal &&
    css`
      grid-column-start: 1;
    `}

  p {
    color: ${nafColor.signature.black} !important;
  }

  a {
    text-decoration: underline;
  }

  @media (max-width: ${breakpoints.l}) {
    grid-column-start: 1;
  }

  @media (max-width: ${breakpoints.m}) {
    margin-bottom: ${spacing.space16};
  }
`;

export const StyledUserInteraction = styled(UserInteraction)`
  width: 100%;
`;
